import { Card, Heading, Button, Pane, toaster, TrashIcon, DocumentIcon } from 'evergreen-ui';
import attachmentServices from '../services/attachmentServices';
import { useState } from 'react';
import '../styles/responsive.css';

const AttachmentList = ({ attachments, setAttachments, isDirector }) => {
    const handleRemoveAttachment = async (id) => {
        try {
            await attachmentServices.deleteAttachment(id);
            setAttachments((prev) => prev.filter((attachment) => attachment.id !== id));
            toaster.notify('Allegato rimosso con successo.');
        } catch (error) {
            console.error('Errore nella rimozione dell\'allegato:', error);
            toaster.danger('Errore nella rimozione dell\'allegato.');
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleString();
    };

    const [sortOrder, setSortOrder] = useState('desc');

    return (
        <Pane>
            <Pane marginBottom={16} display="flex" justifyContent="flex-start" gap={16}>
                <Button
                    appearance="primary"
                    intent="success"
                    onClick={() => {
                        setAttachments((prev) => {
                            const sorted = [...prev].sort((a, b) => {
                                const dateA = new Date(sortOrder === 'asc' ? a.uploaded_at : b.uploaded_at);
                                const dateB = new Date(sortOrder === 'asc' ? b.uploaded_at : a.uploaded_at);
                                return dateA - dateB;
                            });
                            return sorted;
                        });
                        setSortOrder((prev) => (prev === 'asc' ? 'desc' : 'asc'));
                    }}
                >
                    Ordina per data di caricamento {sortOrder === 'asc' ? '↑' : '↓'}
                </Button>
            </Pane>
            {attachments.map((attachment, index) => (
                <Card key={attachment.id || `attachment-${index}`} className="card-flex" elevation={1} padding={16} marginBottom={8}>
                    <Pane className="card-header" display="flex" justifyContent="space-between" alignItems="center">
                        <Heading
                            size={500}
                            marginBottom={8}
                            cursor="pointer"
                            onClick={() => window.open(attachment.url, '_blank')}
                        >
                            <DocumentIcon marginRight={8} /> {attachment.name}
                        </Heading>
                        <Pane>
                            <div className="date-line">Caricato: {formatDate(attachment.uploaded_at)}</div>
                        </Pane>
                    </Pane>
                    <Pane className="card-body" />
                    {isDirector && (
                        <Pane className="card-actions">
                            <Button intent="danger" onClick={() => handleRemoveAttachment(attachment.id)}>
                                Rimuovi <TrashIcon marginLeft={8} />
                            </Button>
                        </Pane>
                    )}
                </Card>
            ))}
        </Pane>
    );
};

export default AttachmentList;